import { render, staticRenderFns } from "./WalletDetails.vue?vue&type=template&id=122ffc7d&scoped=true"
import script from "./WalletDetails.vue?vue&type=script&lang=js"
export * from "./WalletDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ffc7d",
  null
  
)

export default component.exports